import { ReactQueryDynamicDevTools } from '@quickmd-llc/design-system'
import { QueryClientProvider } from '@tanstack/react-query'
import { type PropsWithChildren, useEffect } from 'react'
import { broadcastQueryClient } from '@tanstack/query-broadcast-client-experimental'
import { isDevToolsEnabled } from '../../features/devTools/isDevToolsEnabled'
import { queryClient } from './queryClient'

export function ReactQueryProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    const isBrowser = typeof window !== 'undefined' && 'BroadcastChannel' in window
    if (!isBrowser) return
    const unsubscribe = broadcastQueryClient({
      queryClient,
      broadcastChannel: 'react-query',
    })

    return () => {
      unsubscribe()
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDynamicDevTools isDevToolsEnabled={isDevToolsEnabled} />
      {children}
    </QueryClientProvider>
  )
}
